import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllProcedures = async (
  isGlobalTemplate = false,
  organisationID = "",
  
  searchName = "",
  page = 1,
  pageSize = 9999,
  category,
  createdby = [],
  createdat = [],
  sort = [],
  assets = []
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
    isGlobalTemplate: {
      $eq: isGlobalTemplate,
    },
    category: {
      $in: category,
    },
    createdByUser: {
      id: {
        $in: createdby,
      },
    },
    assets: {
      id: {
        $in: assets,
      },
    },
  };

  if (createdat.length === 1) {
    assetFilters.createdAt = {
      $gte: createdat[0],
    };
  } else if (createdat.length === 2) {
    assetFilters.createdAt = {
      $gte: createdat[0],
      $lte: createdat[1],
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "fields",
      "fields.logics",
      "fields.options",
      "createdByUser",
      "fields.attachments",
      "headers",
      "headers.fields",
      "headers.fields.logics",
      "headers.fields.options",
      "createdByUser",
      "fields.attachments",
      "headers.fields.attachments",
      "assets",
      "assets.location",
      "parts",
      "locations",
      "createdByUser.profileImage",
      "updatedByUser",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }
  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });
  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `procedures?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
